export enum PersonnesPath {
  ROOT = '',
  CREATION = 'creation-personne',
  EDITION = 'edition-personne',
  EDITION_GENERAL = 'general',
  LISTE_INSCRIPTIONS = 'inscriptions',
  ID_PERSONNE_PARAM = 'idPersonne',
  CREATION_INSCRIPTION = 'creation-inscription',
  LISTE_FACTURES = 'factures',
  DOCUMENTS = 'documents',
  TACHES = 'taches',
  EDITION_UTILISATEUR = 'edition-utilisateur'
}
